const useStyles = theme => ({
  itemContainer: {
    padding: '10px'
  },
  cardContainer: {
    overflow: 'hidden'
  },
  twoVerticalRowsContainer: {
    height: 150,
    [theme.breakpoints.down('sm')]: {
      height: 70
    }
  },
  mainTitle: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    wordBreak: "break-word",
    overflow: "hidden",
    marginLeft: 15,
    marginRight: 10,
    marginTop: 10,
    [theme.breakpoints.only('md')]: {
      marginTop: 15,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 10
    }
  },
  secondaryTitle: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    wordBreak: "break-word",
    overflow: "hidden",
    marginLeft: 15,
    marginRight: 20,
    marginTop: 8,
    [theme.breakpoints.down('sm')]: {
      visibility: 'hidden'
    }
  },
});

export default useStyles
